import { Component, Input, OnInit, Sanitizer } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'podcast-modulo',
  templateUrl: './podcast-modulo.component.html',
  styleUrls: ['./podcast-modulo.component.scss']
})
export class PodcastModuloComponent implements OnInit {

  @Input("data") data:any = null; 
  public parcerias = [];
  public link = null;

  constructor(
    public sanitizer: DomSanitizer
  ){ }

  /**
   * 
   * Set link
   * 
   */
  setLink(){

    this.link = this.sanitizer.bypassSecurityTrustResourceUrl("https://open.spotify.com/embed/show/45mfLC4WB8daZVJQbZBoL8");

  }
  /**
   * 
   * Incializa as Funções
   * 
   */
  ngOnInit():void{
    this.setLink();
  }


}
